















import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import ProfileAvatar from '@/components/Profile/ProfileAvatar.vue';
import {ActivityModel} from '@/models/activity.model';

@Component({
  components: {
    ProfileAvatar,
  },
})
export default class ProfileActivity extends Vue {
  @Prop({required: false, default: false}) grayBg!: boolean;
  @Prop({required: true}) activity!: ActivityModel;

  get fetchActivityI18n(): string {
    const params = {...this.activity.properties?.parameters};
    return this.$t(`activities.${this.activity.properties.context}.${this.activity.properties.action}`, params).toString()
  }
}
